import React from 'react';
import moment from 'moment';
import { getNumberFormat, colorCategory } from 'utils/helpers';
import CategoryIcons from 'library/categoryIcons';
import NoDataMsg from 'library/noData';


const Body = ({ gmroi, selectedDate }) => (
    <div>
    {
        gmroi.length <= 0 ? 
        //If there's NO DATA to display
        <NoDataMsg/>
        : 
        //If there's DATA
        <div>
            <div className="text-center list_header">
                {selectedDate ? 
                <p><i>Selected Date</i> <b>{moment(selectedDate).format('MMMM Do, YYYY')}</b></p>
                : ""}
            </div>

            <div className="mt-2 pl-2 pr-2">
                         
                <div>
                    <table className="table table-striped table-hover table-responsive">
                        <thead>
                            <tr>
                                <th className='tableHeaderColorGray'>Category</th>
                                <th className='tableHeaderColorGray'>GMROI</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            gmroi.map((item, index) => {
                                return(
                                    <tr key={index}>
                                        <td className='purpleText'>{item.categoryName}</td>
                                        <td className='purpleText'>{item.gmroi.toFixed(2)}</td>
                                        
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>    
        }
    </div>
);
export default Body;